import React, { Component } from 'react';
import { store } from 'Store/store.index';
import { Tooltip } from 'antd';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import './CollaborationHeader.scss'
import completeSynchronously from 'assets/share/completeSynchronously.svg'
import { collaborationService } from '@/store/services/index';

@inject('collaborationStore', 'teamsAppStore')
@observer
class DocumentNameHeader extends Component {
  constructor(/*props*/) {
    super();
  }
  componentDidMount() { }
  backHome = () => {
    /*store.historyStore.goToHomePage()
    store.collaborationStore.clearTimer()
    this.props.showHomeStart()*/
    store.appStore.closeMessageCenterDlg();
    store.collaborationStore.updateIsShowCollaborationSignIn(false)
    const {inTeamsApp} = store.teamsAppStore;
    if (inTeamsApp) {
      return;
    }
    const next=()=>{
      collaborationService.showCommonModeSidebar()
      store.collaborationStore.exitCollaboration(true)
    }
      setTimeout(() => {
        next()
      }, 200);

  }
  render() {
    const {inTeamsApp} = store.teamsAppStore;
    const { docName, cUserID, userName } = store.collaborationStore.shareReviewData
    const userId = store.userStore.userInfo ? store.userStore.userInfo.cUserID:null;
    const shareOther = (!!userName) ? intl.get('collaboration.sharedList.tabTitleBySharerName', { name: userName }) : intl.get('collaboration.sharedList.tabTitleByOther');
    const shareType = cUserID === userId ? intl.get('collaboration.sharedList.tabTitleByYou') : shareOther;
    return (
      <div className={"DocumentNameHeader left-feature"}>
        { !!inTeamsApp ? <i className={`home-btn icon-btn ${inTeamsApp ? 'disable' : ''}`} onClick={this.backHome} /> :
          <Tooltip getPopupContainer={triggerNode => triggerNode.parentNode} placement="bottomLeft" title={intl.get('HeaderContainer.BackHome')}>
            <i className={`home-btn icon-btn`} onClick={this.backHome} />
          </Tooltip>
        }
        <Tooltip getPopupContainer={triggerNode => triggerNode.parentNode} title={docName}>
          <span className="document-name">{shareType} &gt; {docName}</span>
        </Tooltip>
        <img src={completeSynchronously} alt="" />
      </div>
    )
  }
}

export default DocumentNameHeader
